import React from 'react';
import { GQL } from '@gin-betting/core';
// eslint-disable-next-line no-restricted-syntax
import { Widget } from '@grid-esports/widget-sdk/dist/react';

import './gridPlayer.scss';

interface Props {
    gridEmbedVideoToken: GQL.GridEmbedVideoToken;
}

const GridPlayer: React.FC<Props> = ({ gridEmbedVideoToken }) => {
    const { token, seriesId } = gridEmbedVideoToken;

    return (
        <div styleName="container">
            <Widget
                type="stream"
                scope={{ type: 'series', id: seriesId }}
                options={{ token }}
                theme={{
                    radii: [0, 0],
                    widgetContainer: {
                        showHeader: false,
                        border: 'none',
                    },
                }}
            />
        </div>
    );
};

export default GridPlayer;
